import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
        display: 'flex'
    },
}));

export { useStyles };